import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {savedFiltersCreateMutation, CreateSavedFilterInput} from './__generated__/savedFiltersCreateMutation.graphql';

const mutation = graphql`
	mutation savedFiltersCreateMutation($input: CreateSavedFilterInput!) {
		createSavedFilter(input: $input) {
			clientMutationId
			savedFilter {
				id
				name
				criteria
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: CreateSavedFilterInput,
	onCompleted?: (r: savedFiltersCreateMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<savedFiltersCreateMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'savedFiltersCreateMutation'};
